import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import moment from 'moment';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField/TextField";

import {
  apollo_useStyles,
} from "../../atom/Apollo_styles";
import {
  apollo_billing_resource_master_relation_path,
  apollo_billing_resource_path,
} from "../../atom/Apollo_links";
import {
  BillingResourceMasterRelation,
} from "../../pages/MASTER/MasterModel";
import {
  BillingResourceRequest,
} from "./Apollo_MasterModel";

// 共通部品
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import ApolloTextNumber, {PropsTextNumber} from "../../atom/ACCOUNT/Apollo_TextNumber";
import {ApolloContext} from "../../atom/Apollo_Context";
import {LogData, ApolloEventRecord} from "../../atom/Apollo_EventRecord";
import {checkCommonInvalidTextChar, checkInvalidCharForName} from "../../common/Apollo_CommonUtil";
// メッセージ定義
import {
  GetMessage,
  UI_MASTER_BILLING_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// ドロワー(認証期間切れの場合にドロワーを閉じるため)
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

// INT 安全最大値
const MAX_INT = Number.MAX_SAFE_INTEGER;

export default function Apollo_MasterBillingResourceEdit(props: {
	billingId: number,
	read: boolean,
	setRead: any,
	close: any,
}) {
	const {read, setRead} = props;
  	const {register, handleSubmit, errors} = useForm();
	const classes = apollo_useStyles();
	const {data, setmsg} = React.useContext(ApolloMessage);
	const [master, setMaster] = useState<BillingResourceMasterRelation>();
	const [creditLimitAmount, setCreditLimitAmount] = React.useState(0);
	const [oldCreditLimitAmount, setOldCreditLimitAmount] = React.useState(0);
	const {state: apolloContex} = React.useContext(ApolloContext);
	
	// 再読み込み
	const [reRead, setReRead] = useState(true);

	// ドロワー(認証期間切れの場合にドロワーを閉じるため)
	const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
	// リダイレクト(認証期間切れの場合にリダイレクトするため)
	const history = useHistory();

	useEffect(() => {
		// 新規登録の場合は取得しない
		if (props.billingId === 0) return;

		setmsg({
			type: "loading",
			payload: {
				...data,
				loading: true,
			}
		});
		// 請求リソースマスタ取得
		const path = apollo_billing_resource_master_relation_path + "/" + props.billingId;
		ApolloAxios.get(path).then(response => {
			if (response.data.resultCode === 0) {
				setData(response.data.result);
				setmsg({
					type: "all",
					payload: {
						...data,
						loading: false,
					}
				});
			} else {
				console.log(response.data.message)
				setmsg({
					type: "all",
					payload: {
						...data,
						open: true,
						type: "error",
						message: GetMessage("0",UI_MASTER_BILLING_EDIT,"E","0"),
						loading: false,
					}
				});
			}
		}).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_MASTER_BILLING_EDIT,"E","0"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		});
	}, []);

	// 請求リソースデータ保存
	const setData = (data: BillingResourceMasterRelation) => {
		data.creditLimitAmount = data.creditLimitAmount ? data.creditLimitAmount : 0;
		setMaster(data);
		setCreditLimitAmount(data.creditLimitAmount);
		setOldCreditLimitAmount(data.creditLimitAmount);
	}

	// 変更ボタンハンドラ
  const onSubmit = handleSubmit(async (body: any) => {

		let beforeBillingName = master?.billingName ?? "";
		let afterBillingName = body.billingName;
		let beforeCreditLimitAmount = master?.creditLimitAmount.toString() ?? "0";
		let afterCreditLimitAmount = creditLimitAmount.toString();

		var executeLogData: LogData = {
			eventDate:  moment().format("YYYY-MM-DD HH:mm:ss"),
			logType: "execute", // ログ種別 実行：execute, 結果：result
			result: "", // 実行結果 成功 / 失敗 ※実行時は空文字
			userID: apolloContex.userprofile.userId,
			userName:  apolloContex.userprofile.userName,
			accessToken:  apolloContex.accesstoken,
			displayName: "請求リソースマスタ画面",
			category: "マスタ", // 操作対象 キャンペーン / セグメント etc...
			actionType: "作成",
			accountGroupID: apolloContex.current.accountGroupId,
			accountGroupName: apolloContex.current.accountGroupName,
			accountID: apolloContex.current.accountId,
			accountName: apolloContex.current.accountName,
			campaignID: "", // キャンペーンID
			campaignName: "", // キャンペーン名
			adGroupID: "", // 広告グループID
			adGroupName: "", // 広告グループ名
			targetID: "", // 操作を行うデータのID 実行時は空文字
			targetName: "", // 操作を行うデータの名称 実行時は空文字
			menu: "",
			itemList: [
				{key:"billingName", beforeValue:"", afterValue:afterBillingName},
				{key:"creditLimitAmount", beforeValue:"", afterValue:afterCreditLimitAmount},
			]
		};

		// 請求リソースマスタ登録・更新リクエスト
		var requestMaster:BillingResourceRequest = {
			billingName: body.billingName,
			creditLimitAmount: creditLimitAmount,
		}

		if (props.billingId === 0) {
			// URL
			const url = apollo_billing_resource_path;
			executeLogData.logType = "execute";
			executeLogData.result = "";
			ApolloEventRecord(executeLogData);
			// 請求リソースマスタ登録
			ApolloAxios.post(url, requestMaster).then(response => {
				if (response.data.resultCode === 0) {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "成功";

					ApolloEventRecord(executeLogData);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "success",
							message: GetMessage("0",UI_MASTER_BILLING_EDIT,"I","0"),
						}
					});
					// 呼び出し元・再読み込み
					setRead(!read);
					setReRead(!reRead);
					handleClose();
				} else {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "失敗";

					ApolloEventRecord(executeLogData);
					console.log(response.data.message);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "error",
							message: GetMessage("0",UI_MASTER_BILLING_EDIT,"E","1"),
						}
					});
				}
			}).catch(err => {
				executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
				executeLogData.logType = "result";
				executeLogData.result = "失敗";

				ApolloEventRecord(executeLogData);

				// 認証期間切れ判定とエラーメッセージ表示
				if (!ApolloExpired(err, GetMessage("0",UI_MASTER_BILLING_EDIT,"E","1"), data, setmsg, history, setDrawerState, drawerState)) {
					// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
				}
			})
		} else {
			// URL
			const url = apollo_billing_resource_path + "/" + props.billingId;
			executeLogData.actionType = "更新";
			executeLogData.targetID = props.billingId.toString();
			executeLogData.logType = "execute";
			executeLogData.result = "";
			executeLogData.itemList = [
				{key:"billingName", beforeValue:beforeBillingName, afterValue:afterBillingName},
				{key:"creditLimitAmount", beforeValue:beforeCreditLimitAmount, afterValue:afterCreditLimitAmount},
			];

			ApolloEventRecord(executeLogData);
			// 請求リソースマスタ更新
			ApolloAxios.put(url, requestMaster).then(response => {
				if (response.data.resultCode === 0) {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "成功";

					ApolloEventRecord(executeLogData);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "success",
							message: GetMessage("0",UI_MASTER_BILLING_EDIT,"I","1"),
						}
					});
					// 呼び出し元・再読み込み
					setRead(!read);
					setReRead(!reRead);
					handleClose();
				} else {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "失敗";

					ApolloEventRecord(executeLogData);
					console.log(response.data.message);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "error",
							message: GetMessage("0",UI_MASTER_BILLING_EDIT,"E","2"),
						}
					});
				}
			}).catch(err => {
				executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
				executeLogData.logType = "result";
				executeLogData.result = "失敗";

				ApolloEventRecord(executeLogData);

				// 認証期間切れ判定とエラーメッセージ表示
				if (!ApolloExpired(err, GetMessage("0",UI_MASTER_BILLING_EDIT,"E","2"), data, setmsg, history, setDrawerState, drawerState)) {
					// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
				}
			})
		}
	});

		//// 共通コンポーネントプロパティ定義
	// 与信限度額テキスト引数
	var propsTextNumber:PropsTextNumber = {
		label: "与信限度額",
		setValue: setCreditLimitAmount,
		value: creditLimitAmount,
		minValue: oldCreditLimitAmount,
		maxValue: MAX_INT,
		isDisabled: false,
		required: false,
	};

	// キャンセルボタンハンドラ
  const handleClose = () => {
		props.close();
	}

	//// 画面表示
	return (
		<div className={classes.root}>
      <form noValidate onSubmit={onSubmit}>
			<Card square variant="outlined" style={{height: 500}}>
				<CardContent style={{padding:10}}>
					<Card className={classes.root} square variant="outlined" style={{height: 420}}>
						<CardContent style={{padding:10}}>
							{/* 請求リソースID */}
							<Grid item xs={12}>
                <TextField
                  id="billingId"
                  name="billingId"
                  label="請求リソースID"
                  fullWidth
                  key={master ? "Loaded" : "Loading"}
                  defaultValue={master && master.billingId}
                  autoComplete="請求リソースID"
									disabled={true}
                />
              </Grid>
							{/* 請求リソース名称 */}
							<Grid item xs={12}>
                <TextField
                  id="billingName"
                  name="billingName"
				  label="請求リソース名"
				  inputRef={register({
					  required: "必須入力項目です。",
					  maxLength: {
						  value: 255,
						  message: "255文字以内で入力して下さい。"
					  },
					  validate: (e: string) => {
						  const errorMessage = checkInvalidCharForName(e)
						  if(errorMessage) {
							  return errorMessage
						  }},
                  })}
                  required
                  fullWidth
                  key={master ? "Loaded" : "Loading"}
                  defaultValue={master && master.billingName}
                  helperText={errors.billingName && errors.billingName.message}
                  error={errors.billingName ? true : false}
                  autoComplete="請求リソース名"
                />
              </Grid>
							<Grid item xs={12}>
								{/* 与信限度額 */}
								<ApolloTextNumber propsText={propsTextNumber}/>
							</Grid>
							※与信限度額は増額のみ
						</CardContent>
					</Card>
				</CardContent>
				<Button className={classes.buttonTop} variant="contained" color="primary" onClick={onSubmit}>
					{props.billingId === 0 ?
						"新規に登録"
					:
						"変更を保存"
					}
					</Button>
					<Button className={classes.buttonTop} variant="contained" color="primary" onClick={()=>handleClose()}>
					キャンセル
					</Button>
			</Card>
			</form>
		</div>
	);
}
